import { useOne, useTranslate, Authenticated } from "@refinedev/core";
import { useParams } from "react-router-dom";
import { MediaProjectResponse } from "pages/media/types";
import { Flex } from "antd";
import { DownloadSimpleIcon } from "@phosphor-icons/react";
import { createRef } from "react";
import { SubPageHeader } from "../../../../components/SubPageHeader";
import { FatButton } from "components/FatButton/FatButton/";

// Deprecated? Or have to be 🙂
export const DownloadMediaPage = () => {
  const { id, mediaId } = useParams();
  const t = useTranslate();
  const linkRef = createRef<HTMLAnchorElement>();

  const { data: projectData } = useOne<MediaProjectResponse>({
    resource: `media/projects`,
    id: id,
  });
  const handleDownload = () => {
    return linkRef.current?.click();
  };

  const media = projectData?.data.media.find((item) => item.id === mediaId);

  return (
    <Authenticated key="project_download">
      <SubPageHeader
        itemId={id}
        itemTitle={projectData?.data.title}
        page="download"
        source="projects"
        spaced
      />

      <a
        ref={linkRef}
        rel="noreferrer"
        target="_blank"
        style={{ display: "none" }}
        download={media?.url}
        href={media?.url}
      ></a>

      <Flex justify="start">
        <FatButton
          disabled={!media?.url}
          title={t("projects.components.DownloadButton.download")}
          key="download"
          onClick={handleDownload}
          icon={<DownloadSimpleIcon size={27} />}
        />
      </Flex>
    </Authenticated>
  );
};
